export const paths = {
  login: "/login",
  projects: "/projects",
  sprints: (projectId) => `/projects/${projectId}/sprints`,
  inconsistencies: (projectId, sprintIds = []) =>
    `/projects/${projectId}/inconsistencies?sprints=${sprintIds.join(",")}`,
};
